import { render, staticRenderFns } from "./AddAssetCard.vue?vue&type=template&id=8d8c0466&scoped=true&"
import script from "./AddAssetCard.vue?vue&type=script&lang=js&"
export * from "./AddAssetCard.vue?vue&type=script&lang=js&"
import style0 from "./AddAssetCard.vue?vue&type=style&index=0&id=8d8c0466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c0466",
  null
  
)

export default component.exports